import React, { Component } from 'react'

export default class Privacy extends Component {
    render() {
        return (
            <p>
                We take your privacy seriously. 
                View our&nbsp; 
                <a href="https://newtopia.com/b2c/privacy-policy/" target="_blank" rel="noopener noreferrer">
                    privacy policy
                </a>
                .
            </p>
        )
    }
}